// // @ts-ignore
// import { Mp3Encoder } from 'lamejs';

// export const encodeToMp3 = async (audioBlob) => {
//   const audioContext = new AudioContext();
//   const arrayBuffer = await audioBlob.arrayBuffer();
//   const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

//   const samples = audioBuffer.getChannelData(0);
//   const sampleRate = audioBuffer.sampleRate;
//   const mp3encoder = new Mp3Encoder(1, sampleRate, 128);

//   const mp3Data = [];
//   const sampleBlockSize = 1152;

//   for (let i = 0; i < samples.length; i += sampleBlockSize) {
//     const sampleChunk = samples.subarray(i, i + sampleBlockSize);
//     const int16Samples = new Int16Array(sampleChunk.length);

//     for (let j = 0; j < sampleChunk.length; j++) {
//       int16Samples[j] = sampleChunk[j] * 32767.5;
//     }

//     const mp3buf = mp3encoder.encodeBuffer(int16Samples);
//     if (mp3buf.length > 0) mp3Data.push(mp3buf);
//   }

//   const finalMp3 = mp3encoder.flush();
//   if (finalMp3.length > 0) mp3Data.push(finalMp3);

//   return new Blob(mp3Data, { type: 'audio/mp3' });
// };


import { FFmpeg } from '@ffmpeg/ffmpeg';

const ffmpeg = new FFmpeg();

export const convertWebmToMp3 = async (webmBlob) => {
  if (!ffmpeg.loaded) {
    await ffmpeg.load();
  }

  const data = new Uint8Array(await webmBlob.arrayBuffer());
  await ffmpeg.writeFile('input.webm', data);

  await ffmpeg.exec(['-i', 'input.webm', '-vn', '-ar', '44100', '-ac', '2', '-b:a', '192k', 'output.mp3']);

  const output = await ffmpeg.readFile('output.mp3');
  return new Blob([output.buffer], { type: 'audio/mpeg' });
};